import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import JoinGroupBuyRecord from '../../entities/booking/joinGroupBuyRecord';

interface JoinGroupBuyRecordState extends ListState<JoinGroupBuyRecord>{
    editJoinGroupBuyRecord:JoinGroupBuyRecord
}
class JoinGroupBuyRecordModule extends ListModule<JoinGroupBuyRecordState,any,JoinGroupBuyRecord>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<JoinGroupBuyRecord>(),
        loading:false,
        editJoinGroupBuyRecord:new JoinGroupBuyRecord()
    }
    actions={
        async getAll(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/JoinGroupBuyRecord/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<JoinGroupBuyRecord>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            await Ajax.post('/api/services/app/JoinGroupBuyRecord/Create',payload.data);
        },
        async createWithImages(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            await Ajax.post('/api/services/app/JoinGroupBuyRecord/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            await Ajax.put('/api/services/app/JoinGroupBuyRecord/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            await Ajax.put('/api/services/app/JoinGroupBuyRecord/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/JoinGroupBuyRecord/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<JoinGroupBuyRecordState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/JoinGroupBuyRecord/Get?Id='+payload.id);
            return reponse.data.result as JoinGroupBuyRecord;
        }
    };
    mutations={
        setCurrentPage(state:JoinGroupBuyRecordState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:JoinGroupBuyRecordState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:JoinGroupBuyRecordState,joinGroupBuyRecord:JoinGroupBuyRecord){
            state.editJoinGroupBuyRecord=joinGroupBuyRecord;
        },
        changeLoading(state:JoinGroupBuyRecordState,pass:boolean){
            state.loading = pass;
        }
    }
}
const joinGroupBuyRecordModule=new JoinGroupBuyRecordModule();
export default joinGroupBuyRecordModule;